import { useQuery } from 'react-query';
import { getClientFlowsByCriteria, GetClientFlowsByCriteriaParams, getSupplierFlowsByCriteria, GetSupplierFlowsByCriteriaParams, getThirdPartyFlowsByCriteria } from 'services/PaymentServices';

export function useGetFlowsByCriteria(
  requestSupplier?:GetSupplierFlowsByCriteriaParams | any,
  requestClient?: GetClientFlowsByCriteriaParams | any,
  flow?:"IN"|"OUT"|"BOTH",
  enabled: boolean = true,
) {
  const clientQueryResult = useQuery(
    ['getClientFlowsByCriteria', requestClient],
    () => getClientFlowsByCriteria( requestClient ).then((res) => res.list),
    {
       enabled: flow === 'IN',
    }
  );

  const supplierQueryResult = useQuery(
    ['getSupplierFlowsByCriteria',requestSupplier],
    () => getSupplierFlowsByCriteria( requestSupplier ).then((res) => res.list),
    {
       enabled: flow === 'OUT',
    }
  );

  const thirdPartyQueryResult = useQuery(
    ['getThirdPartyFlowsByCriteria',requestSupplier],
    () => getThirdPartyFlowsByCriteria( requestSupplier ).then((res) => res.list),
    {
       enabled: flow === 'BOTH',
    }
  );

  

  return flow === 'IN' ? clientQueryResult : flow==='OUT'?supplierQueryResult:thirdPartyQueryResult;
}
